<template>
  <div class="hello">

    <b-container>
        <transition name="fade">
            <div v-if="gettingOrder" class="loading">
                <p>Getting Order Details...</p>
            </div>
        </transition>

        <transition name="fade">
            <div v-if="showSuccess" class="loading">
                <p>Order Change Request Sent To Buyer</p>
            </div>
        </transition>

        <h4 style="margin-top:20px">Suggest An Order Change</h4>
        <!-- Error message -->
        <div style="color:red" v-if="errMsg">{{errMsg}}</div>

        <!-- If not logged in, show login modal and button -->
        <div v-if="!isTheUserLoggedIn">
            <h6>You just be logged in to edit this order</h6>
            <b-button variant='info' @click="showLoginModal=true">Login</b-button>
            <!-- Login modal -->
            <b-modal title="Must be logged in" v-model="showLoginModal" id="theloginmodal" :hide-footer="true">
                <loginmodal @closeLoginModal="closeLoginModal" id='loginmodal' />
            </b-modal>
        </div>

        <!-- If logged in, then let user edit order, if not already edited -->
        <!-- Order already changed or accepted -->
        <div v-if="order.suggestedstatus||order.status!=0&&isCorrectUser">
            <h4>This order has already been edited or updated. It cannot be edited again.</h4>
        </div>

        <!-- Order still open -->
        <div v-if="!order.suggestedstatus&&order.status==0&&isCorrectUser">
            <!-- Show edit order modal -->
            <editorder :theOrder="order" @closeEditModal="closeEditModal" />
        </div>
        
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')
import Loginmodal from '../Loginmodal'
import Editorder from './Editorder'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
        Loginmodal,
        Editorder,
    },

    data() {
        return {
            errMsg:"",
            gettingOrder:false,
            suborderid:'',
            acceptStatus:'',
            order:{},
            cancelMessage:'',
            isTheUserLoggedIn:false,
            performingRequest:false,
            showLoginModal:false,
            isCorrectUser:false,
            showSuccess:false,

        }
    },

    methods:{

        //Close login modal
        closeLoginModal(modalid, success){
            console.log("Received login modalid=" + modalid)
            console.log("Received login success=" + success)
            if(success){
                this.isTheUserLoggedIn=true
                this.getOrder()
            } 
            else this.isTheUserLoggedIn=false
            this.showLoginModal=false
        },
        
        //Get the order
        getOrder(){
            this.gettingOrder=true
            var fbref = fb.ordersCollection
            console.log("Getting order")
            fbref.where('suborderid', '==', this.suborderid).get().then(docs => {
                this.gettingOrder=false
                docs.forEach(doc => {
                    let theOrderData = doc.data()
                    theOrderData.docId=doc.id
                    this.order = theOrderData
                    this.isTheUserLoggedIn=true
                    this.performingRequest = false
                    //Check if correct user logged in
                    if(this.currentUser.uid!=theOrderData.brewerid){
                        this.errMsg="The order does not belong to the current user"
                        this.isCorrectUser=false
                    }
                    else this.isCorrectUser=true

                })
            }).then(res => {
                this.gettingOrder=false
            })
            .catch(err => {
                this.gettingOrder=false
                console.log(err)
            })
        },

        //Close edit modal and go to order
        closeEditModal(suborderid, success){
            console.log("Received Success = " + success)
            if(success==1){
                this.showSuccess=true
                setTimeout(() => { 
                    this.showSuccess = false 
                    this.$router.push({path:'/login'})
                }, 1500)
            }
            else this.$router.push({path:'/login'})

        },
    },

    mounted(){
        if(this.$route.params.suborderid ){
            console.log("subrdorderid: " + this.$route.params.suborderid)
            this.suborderid = this.$route.params.suborderid
        }
        //Check valid suborderid and status
        if(!this.$route.params.suborderid) this.errMsg="Invalid Order"

        //Check logged in
        if(this.currentUser){
            console.log("User exists")
            this.isTheUserLoggedIn=true
            this.getOrder()
        } 
        else{
            console.log("No user")
            this.isTheUserLoggedIn=false
            this.showLoginModal=true
        }
    },
}
</script>

